module.exports = __webpack_public_path__ + "static/media/dashboard-fill.7a7bda4e.svg";